module.exports = __webpack_public_path__ + "img/sketch-white-start.3dbac154.png";